<template>
  <div class="substep-view-unusual-activity">
    <div class="substep-header">
      <h3 data-testId="step-title">View unusual activity</h3>
      <p>See if any of your team members are using suspicious apps to generate fake activity.</p>
    </div>
    <div class="substep-body">
      <div class="totals">
        <div class="card members">
          <div class="value">
            {{ totalMembers }}
          </div>
          <div class="description">Members</div>
        </div>

        <div class="card instances">
          <div class="value">
            {{ totalInstances }}
          </div>
          <div class="description">Instances</div>
        </div>

        <div class="card total-time">
          <div class="value">
            {{ totalTime }}
          </div>
          <div class="description">Total time</div>
        </div>
      </div>

      <div class="table-title">
        Members with unusual activity
        <i
          v-tooltip="{ placement: 'top' }"
          class="hi hi-info-filled text-grey hi-12"
          :data-original-title="unusualActivityTooltip"
        ></i>
      </div>

      <AppTable
        :table-data="members"
        scrollable
        class="member-table"
      >
        <AppTableColumn
          v-slot="{ row }"
          header="Member"
          name="member"
        >
          <div class="member">
            <AppAvatar
              :avatar="row.avatar"
              size="speck"
            />

            <span
              :title="row.name"
              class="line-clamp-2 w-fit"
              v-text="row.name"
            ></span>
          </div>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="This week"
          name="this week"
          cell-classes="weekly min-width w-fit"
          header-classes="weekly"
        >
          <span
            :title="row.weekly_activity"
            class="line-clamp-2 w-fit"
            v-text="row.weekly_activity"
          ></span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header="Previous 60 days"
          name="Previous 60 days"
          cell-classes="bi-monthly min-width max-width"
          header-classes="bi-monthly"
        >
          <span
            :title="row.bi_monthly_activity"
            class="line-clamp-2 w-fit"
            v-text="row.bi_monthly_activity"
          ></span>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          cell-classes="confidence min-width"
          header-classes="confidence"
          header="Activity classification"
          :header-tooltip="INSIGHTS.tooltips.confidenceLevel.content"
          header-tooltip-type="info-filled"
          name="confidence"
        >
          <div
            class="unusual-activity-confidence-label"
            :class="row.confidence.toLowerCase()"
          >
            {{ row.confidence }}
          </div>
        </AppTableColumn>

        <AppTableColumn
          v-slot="{ row }"
          header-classes="text-align-right"
          cell-classes="text-align-right"
          header=""
          name="action"
        >
          <AppButton
            class="modal-launcher"
            @click="openViewDialog(row)"
          >
            View
          </AppButton>
        </AppTableColumn>
      </AppTable>
    </div>
    <MemberUnusualActivityDialog
      v-if="showMemberDialog"
      :show="showMemberDialog"
      :member="selectedMember"
      @close="closeDialog"
    ></MemberUnusualActivityDialog>
  </div>
</template>

<script>
import AppButton from '~/components/AppButton.vue';
import MemberUnusualActivityDialog from './components/MemberUnusualActivityDialog.vue';
import GettingStartedMixin from '~/mixins/GettingStarted/GettingStartedMixin';
import { INSIGHTS } from '~/app_constants';

export default {
  name: 'ViewUnusualActivity',
  components: {
    AppButton,
    MemberUnusualActivityDialog,
  },
  mixins: [GettingStartedMixin],
  props: {
    members: {
      type: Array,
      required: true,
      validator: (members) => {
        return members.every((member) => {
          return member.name && member.instances;
        });
      },
    },
    totalMembers: {
      type: Number,
      default: 0,
    },
    totalInstances: {
      type: Number,
      default: 0,
    },
    totalTime: {
      type: String,
      default: '0:00',
    },
  },
  data: () => ({
    selectedMember: {},
    showMemberDialog: false,
  }),
  computed: {
    INSIGHTS() {
      return INSIGHTS;
    },
    unusualActivityTooltip() {
      return 'View members with unusually high/low mouse or keyboard activity, or who are using apps that may simulate activity during work.';
    },
  },
  beforeMount() {
    this.$emit('completeSubstep');
  },
  methods: {
    openViewDialog(member) {
      this.selectedMember = member;
      this.showMemberDialog = true;
    },
    closeDialog() {
      this.selectedMember = {};
      this.showMemberDialog = false;
    },
  },
};
</script>
